import { z } from "zod";

export const CountResponseSchema = z.object({
    count: z.number(),
});
